<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">API Management</h6>
            <div>
              <div class="w-full lg:w-12/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">View Type</label>
                <select v-model="filter.view_type"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="changeViewType()">
                  <option v-for="(item, key) in filterClients['view_type']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

            </div>
          </div>
          <br />
          <hr />
          <div class="text-center flex justify-between py-6">
            <div class="w-full lg:w-12/12 flex flex-wrap">

              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">App Name</label>
                <select v-model="filter.app_name"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="getVersions()">
                  <option v-for="(item, key) in filterClients['app_name']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Version</label>
                <select v-model="filter.version"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="getIntentions()">
                  <option v-for="(item, key) in filterClients['version']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Intention</label>
                <select v-model="filter.intention"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                  <option v-for="(item, key) in filterClients['intention']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="w-full lg:w-4/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Date</label>
                <vue-tailwind-datepicker v-model="dateValue" :formatter="formatter" :disable-date="disabledDates" />
              </div>

              <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="search()">
                Search
              </a>
              <a class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="clear()">
                x
              </a>
            </div>
          </div>
        </div>
        <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div class="flex flex-wrap items-center">
            <div class="relative w-full max-w-full flex-grow flex-1">
              <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
                Client's Reports
              </h6>
              <h2 class="text-blueGray-700 text-xl font-semibold">
                Total orders
              </h2>
            </div>
          </div>
        </div>
        <div class="p-4 flex-auto">
          <div class="relative h-350-px">
            <canvas id="bar-chart"></canvas>
          </div>
        </div>
        <div class="p-4 flex-auto" v-if="this.priceGroups.length > 0">
          <div class="relative w-full">
            <table class="table-fixed w-full">
              <thead>
                <tr>
                  <th
                    class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-bold text-left">
                    Services
                  </th>
                  <th
                    class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-bold text-left">
                    Count
                  </th>
                  <th
                    class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-bold text-left">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in this.priceGroups" :key="key">
                  <td
                    class="px-6 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap">
                    {{ item.name }}</td>
                  <td
                    class="px-6 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap">
                    {{ item.count }}</td>
                  <td
                    class="px-6 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap">
                    {{ this.toRupiah(item.price) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import ReportDataService from "@/services/ReportDataService";
import FilterDataService from "@/services/FilterDataService";
import ErrorHandler from "@/ErrorHandler";
import Chart from "chart.js";
import { ref } from 'vue'
import VueTailwindDatepicker from 'vue-tailwind-datepicker'

const moment = require("moment");


export default {
  setup() {
    const appStore = UseAppStore();
    const disabledDates = (date) => {
      return date > new Date();
    }

    const dateValue = ref({
      start: moment().subtract(6, 'days').format('DD MMM YYYY'),
      end: moment().format('DD MMM YYYY'),
    });
    const formatter = ref({
      date: 'DD MMM YYYY',
      month: 'MMM'
    })

    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("client", "Client Management", "/admin/client")
    return {
      appStore,
      dateValue,
      formatter,
      disabledDates
    }
  },
  mounted: function () {
    this.$nextTick(function () {

      let ctx = document.getElementById("bar-chart").getContext("2d");
      window.myBar = new Chart(ctx, this.config);
    });
    this.getClient()
    this.getAppNames()
  },
  data() {
    return {
      priceGroups: [],
      config: {
        type: "bar",
        data: {
          labels: [],
          datasets: [],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          title: {
            display: false,
            text: "Orders Chart",
          },
          tooltips: {
            intersect: false,
            displayColors: true,
            callbacks: {
              mode: 'x',
            }
          },
          hover: {
            mode: "nearest",
            intersect: true,
          },
          legend: {
            labels: {
              fontColor: "rgba(0,0,0,.4)",
            },
            align: "end",
            position: "bottom",
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                display: true,
              },
            ],
            yAxes: [
              {
                stacked: true,
                display: true,
                scaleLabel: {
                  display: false,
                  labelString: "Value",
                },
                gridLines: {
                  borderDash: [2],
                  drawBorder: false,
                  borderDashOffset: [2],
                  color: "rgba(33, 37, 41, 0.2)",
                  zeroLineColor: "rgba(33, 37, 41, 0.15)",
                  zeroLineBorderDash: [2],
                  zeroLineBorderDashOffset: [2],
                },
              },
            ],
          },
        },
      },
      params: {
        client_name: this.$route.params.id,
        date_start: moment().subtract(6, 'days').format('YYYY-MM-DD'),
        date_end: moment().format('YYYY-MM-DD'),

      },
      alertType: '',
      alertMessage: '',
      filter: {
        view_type: 'Daily',
        client_name: this.$route.params.id,
      },
      filterClients: {
        view_type: ['Daily', 'Monthly']
      },
    }
  },
  components: {
    VueTailwindDatepicker
  },
  methods: {
    updateData() {
      window.myBar.update()
    },
    getAppNames() {
      this.filter = {
        view_type: this.filter.view_type,
        client_name: this.filter.client_name
      }
      this.filterClients['version'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['app_name'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getVersions() {
      this.filter = {
        view_type: this.filter.view_type,
        client_name: this.filter.client_name,
        app_name: this.filter.app_name,
      }
      this.filterClients['intention'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['version'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getIntentions() {
      this.filter = {
        view_type: this.filter.view_type,
        client_name: this.filter.client_name,
        app_name: this.filter.app_name,
        version: this.filter.version
      }
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['intention'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    search() {
      console.log(this.dateValue)
      this.params.date_start = moment(this.dateValue.start, "DD MMM YYYY").format('YYYY-MM-DD');
      this.params.date_end = moment(this.dateValue.end, "DD MMM YYYY").format('YYYY-MM-DD');
      this.getClient()
    },
    clear() {
      document.location.reload()
    },
    changeViewType() {
      this.search()
    },
    toRupiah: value => 'IDR ' + (value + '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, "."),
    getClient() {
      // let today = new Date()

      let newParams = this.filter
      newParams['client_name'] = this.params.client_name
      newParams['date_start'] = this.params.date_start
      newParams['date_end'] = this.params.date_end
      newParams['group_by'] = 'intention'

      ReportDataService.get(newParams)
        .then(response => {
          if (this.filter.view_type == 'Daily') {
            this.setupDailyData(response)
          } else if (this.filter.view_type == 'Monthly') {
            this.setupMonthlyData(response)
          }
          this.priceGroups = response.data.data.price_groups
          this.updateData()
        })
        .catch(e => {
          console.log(e)
        });
    },
    setupDailyData(response) {
      // let dataCount = []
      let groupDataList = []
      let groupDataObj = {}
      this.config.data.labels = []
      //buat group data
      response.data.data.count.map(item => {
        item.groups.map(groupdata => {
          groupDataList.indexOf(groupdata.name) === -1 ? groupDataList.push(groupdata.name) : console.log("This item already exists", groupdata.name);
        })
      })

      //create array kosong
      for (let i = 0; i < groupDataList.length; i++) {
        groupDataObj[groupDataList[i]] = [];
      }

      //isi group data
      response.data.data.count.map(item => {
        this.config.data.labels.push(moment(new Date(item.date)).format('DD MMM'))
        // dataCount.push(item.count)
        for (let i = 0; i < groupDataList.length; i++) {
          let found = false
          item.groups.map(groupdata => {
            if (groupdata.name == groupDataList[i]) {
              groupDataObj[groupdata.name].push(groupdata.count)
              found = true
            }
          })
          if (!found) {
            groupDataObj[groupDataList[i]].push(0)
          }
        }
      })
      console.log(groupDataObj)
      this.config.data.datasets = []

      //inject dataset 
      Object.entries(groupDataObj).forEach(([key, value]) => {
        console.log(`${key} ${value}`);

        var letters = '0123456789ABCDEF'.split('');
        var barColor = '#';
        for (var i = 0; i < 6; i++) {
          barColor += letters[Math.floor(Math.random() * 16)];
        }
        this.config.data.datasets.push(
          {
            label: `${key}`,
            backgroundColor: barColor,
            borderColor: "#ed64a6",
            data: groupDataObj[`${key}`],
            fill: false,
            barPercentage: 0.5,
            // barThickness: 60,
          }
        )
      });



    },
    setupMonthlyData(response) {
      this.config.data.labels = moment.monthsShort()

      this.config.data.datasets = [{
        label: this.filter.view_type,
        backgroundColor: "#ed64a6",
        borderColor: "#ed64a6",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        fill: false,
        barThickness: 8,
      }]

      response.data.data.count.map(item => {
        let index = moment(new Date(item.date)).format("M") - 1
        console.log(this.config.data.datasets[0].data[index])
        this.config.data.datasets[0].data[index] = this.config.data.datasets[0].data[index] + item.count
      })
    }
  }
};
</script>
